<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="systemDictionaryInfoVo.pkid > 0 ? '编辑' : '新建'"
        class="systemDictionaryEdit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="systemDictionaryInfoVo"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col>
            <el-form-item label="名称" prop="itemName">
              <el-input v-model="systemDictionaryInfoVo.itemName" placeholder="请输入名称"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="数据值" prop="itemId">
              <el-input v-model="systemDictionaryInfoVo.itemId" placeholder="请输入数据值"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      masterId: {
        type: [String, Number],
      },
    },
    data() {
      return {
        submitLoading: false,
        contentLoading: false,
        dialogVisible: false,
        systemDictionaryInfoVo: {
          itemId: "",
          itemName: "",
          pkid: 0,
        },
        ruleValidate: {
          itemName: {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          itemId: {
            required: true,
            message: "请输入数据值",
            trigger: "blur",
          },
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.systemDictionaryInfoVo = Object.assign(this.systemDictionaryInfoVo,row);
        }
      },

      // 新建
      addDictionaryInfo() {
        this.systemDictionaryInfoVo.masterId = this.masterId;
        this.submitLoading = true;
        this.$http
          .post("basic", "dictionaries/item", this.systemDictionaryInfoVo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("添加成功");
              this.dialogVisible = false;
            }
            this.submitLoading = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },

      // 编辑
      editDictionaryInfo() {
        this.submitLoading = true;
        this.$http
          .put("basic", "dictionaries/item", this.systemDictionaryInfoVo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("编辑成功");
              this.dialogVisible = false;
            }
            this.submitLoading = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },

      // 提交
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.systemDictionaryInfoVo.pkid) {
              this.addDictionaryInfo();
            } else {
              this.editDictionaryInfo();
            }
          }
        });
      },
    },
  };
</script>
